import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, AbstractControlDirective, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { cValidators } from '../../../models/validator';
import { SelectOption } from '../iv-select/iv-select.component';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatRadioChange } from '@angular/material/radio';

declare interface SelectOptGroup {
  label: string;
  items: SelectOption[];
  childselected: number;
}

declare interface Select extends SelectOption, SelectOptGroup { }

@Component({
  selector: 'iv-select-menu',
  templateUrl: './iv-select-menu.component.html',
  styleUrls: ['./iv-select-menu.component.scss']
})
export class IvSelectMenuComponent {

  @Input() name: string = 'ivselect_name';
  @Input() mode: string = 'standard';
  @Input() hidden: boolean;
  @Input() label: string = '';
  @Input() search: boolean = true;
  @Input() value: any = null;
  @Input() submenu: any = null;
  @Input() childsSelected: any = [];
  @Input() formControl: FormControl = new FormControl(this.value);
  @Input() multiple: boolean = true;
  @Input() fullWidth: boolean = false;
  @Input() disabled: boolean = false;
  @Input() disabledRadioGroup: boolean = false;
  @Input() groups: boolean = false;
  @Input() data: Select[] = [];
  @Input() selectClass: string = '';
  @Input() inputDisabled: boolean = false;
  @Input() required: boolean = false;
  @Input() errors: { [key: string]: string } = {
    'required': 'Este campo es requerido.'
  }

  formControlSelect: FormControl = new FormControl(null);
  formGroupRadio: FormGroup = this._formBuilder.group({
    'parent': [null, cValidators.required],
    'radio': [null, cValidators.required]
  });

  multiLevel: boolean = true;
  options: Select[] = this.data;
  initial: boolean = false;
  query: string = '';
  top: number = 62 + 42;
  selectedValue: unknown;
  level: number = 0;

  newArray: any[] = [];
  private control: AbstractControlDirective | AbstractControl;

  @Output() selectionChange: EventEmitter<MatSelectChange> = new EventEmitter<MatSelectChange>();
  @Output() valueChange: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() inputChange: EventEmitter<unknown> = new EventEmitter<unknown>();

  @ViewChild('searchInput', { static: false }) searchInput: MatInput;
  @ViewChild('select', { static: false }) select: MatSelect;

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngAfterViewInit() {
    this.formControl.registerOnChange((res: any) => {
      this.value = this.formControl.value;
      const value = [];
      if (this.value && this.value.length) {
        for (let i = 0; i < this.value.length; i++) {
          value.push(this.value[i].value);
        }
      }
      this.formControlSelect.patchValue(value);
    });
  }

  optionClick(i: number) {
    const result = this.options[i].value
    let value = this.formControl.value;
    if (value) {
      value = value.filter((option: any) => option.value === result);
    }

    let radioValue = null;
    if (value && value.length) {
      radioValue = value[0].childValue;
    }

    this.formGroupRadio.patchValue({
      parent: result,
      radio: radioValue
    });
  }

  radioChange(event: MatRadioChange) {
    const result = event.value;
    if (!result) {
      return;
    }
    let value = this.formControl.value;
    const selectValue = this.formGroupRadio.get('parent').value;
    const selectGroup = [];
    if (value && value.length) {
      let modified = false;
      for (let i = 0; i < value.length; i++) {
        if (value[i].value == selectValue) {
          value[i].childValue = result;
          modified = true;
        }
      }
      if (!modified) {
        value.push({ value: selectValue, childValue: result });
      }

      value.childValue = result;
    } else {
      value = [{ value: selectValue, childValue: result }];
    }
    const selectVal = value.map((option: any) => option.value);
    this.formControlSelect.patchValue(selectVal);
    this.formControl.patchValue(value);
  }

  onOptionSelected(event: MatOptionSelectionChange) {
    if (event.isUserInput) {
      this.selectedValue = event.source.value;
    }
    if (this.select.triggerValue.includes('subdirectory_arrow_right')) {
      this.select.customTrigger = this.select.triggerValue.replace('subdirectory_arrow_right', '');
      this.select.trigger.nativeElement.textContent = this.select.customTrigger;
    }
  }

  change(event: MatSelectChange) {
    const values = this.formControl.value || [];
    this.newArray = values;
    let found = this.newArray.find(res => res.value === this.selectedValue);
    if (found) {
      let clean = this.newArray.findIndex(item => item === found);
      this.newArray.splice(clean, 1);
    }
    this.formControl.patchValue(this.newArray);
    this.selectionChange.emit(event);
    this.valueChange.emit(this.value);
    if (this.select.triggerValue.includes('subdirectory_arrow_right')) {
      this.select.customTrigger = this.select.triggerValue.replace('subdirectory_arrow_right', '');
      this.select.trigger.nativeElement.textContent = this.select.customTrigger;
    }
    this.value = this.newArray;
  }

  openedChange(event: MatSelectChange) {
    if (this.search) {
      if (!event) {
        this.query = '';
        this.filter();
      } else {
        this.searchInput.focus();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue !== changes.data.previousValue) {
      this.data.sort(function (a, b) {
        if ((a.label && b.label) !== 'Ninguno')
        return a.label.localeCompare(b.label);
      });
      this.options = this.data;
      this.initial = true;
    }
    if (changes.value && changes.value.currentValue !== changes.value.previousValue) {
      if (this.value != this.formControl.value) {
        this.formControl.setValue(this.value);
      }
    }
  }

  filter() {
    let q = this.query.trim().toLowerCase();
    this.inputChange.emit(q);
    if (!q) {
      this.options = this.data;
    } else {
      let temp: Select[] = [];
      if (this.groups) {
        temp = this.filterGroups(q);
      } else {
        temp = this.filterNonGroups(q);
      }
      this.options = temp;
    }
  }

  private filterGroups(q: string): Select[] {
    let temp: Select[] = [];
    for (let i = 0; i < this.data.length; i++) {
      let opts: SelectOption[] = this.getMatchingGroupItems(this.data[i], q);
      if (opts.length) {
        let group: Select = { ...this.data[i], items: opts };
        temp.push(group);
      }
    }
    return temp;
  }

  private getMatchingGroupItems(group: Select, q: string): SelectOption[] {
    let opts: SelectOption[] = [];
    for (let i2 = 0; i2 < group.items.length; i2++) {
      if (group.items[i2].label.toLowerCase().indexOf(q) != -1) {
        opts.push(group.items[i2]);
      }
    }
    return opts;
  }

  private filterNonGroups(q: string): Select[] {
    let temp: Select[] = [];
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].label.toLowerCase().indexOf(q) != -1) {
        this.addParent(temp, i);
      }
    }
    return temp;
  }

  addParent(temp: Select[], i: number) {
    if (this.data[i].level) {
      this.multiLevel = true;
      this.addParent(temp, this.data[i].parent);
    }
    if (temp.indexOf(this.data[i]) == -1) {
      temp.push(this.data[i]);
    }
    if (this.data[i].isParent) {
      let ch = this.data.filter(
        element => {
          return i == element.parent && temp.indexOf(element) == -1;
        }
      );
      Array.prototype.push.apply(temp, ch);
    }
  }

  preventSpace(event: KeyboardEvent) {
    if (event.key == 'Space') {
      event.stopPropagation();
    }
  }

  getErrorMessage() {
    this.control = this.formControl;
    if (!this.control) {
      return false;
    }
    return this.control.errors ? Object.keys(this.control.errors).map(field => this.errors[field]) : false;
  }
}
